import { render, staticRenderFns } from "./assessmentCenter.vue?vue&type=template&id=1a978ab0"
import script from "./assessmentCenter.vue?vue&type=script&lang=js"
export * from "./assessmentCenter.vue?vue&type=script&lang=js"
import style0 from "./assessmentCenter.vue?vue&type=style&index=0&id=1a978ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports